// extracted by mini-css-extract-plugin
export default {"createTruckBlock":"Trucks_createTruckBlock__ZA4PG","editModal":"Trucks_editModal__48KOP","deleteModal":"Trucks_deleteModal__t1xTw"};